import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RecruitmentForm } from "../organims/RecruitmentForm";
import TableActions from "../molecules/TableActions";
import axios from "axios";
import { API_BASE_URL } from "../../../config/api";
import { Notifications, notifications } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";

export const RequestPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [request, setRequest] = useState(null);

  // single compact toast helper (page-level only)
  const toast = useCallback((ok, msg) => {
    notifications.clean(); // ensure only one visible
    notifications.show({
      title: ok ? "Success" : "Error",
      message: msg,
      color: ok ? "teal" : "red",
      autoClose: ok ? 1500 : 3000,
      withCloseButton: !ok,
      icon: ok ? <IconCheck size={16} /> : <IconX size={16} />,
      radius: "md",
      styles: { root: { maxWidth: 260, padding: "8px 10px" } },
    });
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || !id) return;

    axios
      .get(`${API_BASE_URL}/api/requests/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setRequest(res.data.data))
      .catch((err) => {
        console.error("Error fetching request:", err);
        toast(false, "Failed to fetch request details.");
      });
  }, [id, toast]);

  const handleApproveSuccess = () => {
    toast(true, "Request approved successfully.");
    // Redirect to PENDING approvals list (not approved list)
    setTimeout(() => navigate("/pending", { replace: true }), 800);
  };

  const handleApproveError = () => {
    toast(false, "Approval failed. Try again.");
  };

  return (
    // page scrolls; background light gray around the centered white card
    <div className="min-h-screen bg-gray-50 overflow-y-auto">
      {/* one notifications host, limit to a single popup */}
      <Notifications position="top-right" containerWidth={260} zIndex={4000} limit={1} />

      {/* Centered content; not full width */}
      <div className="mx-auto w-full max-w-[1000px] px-4 md:px-6 lg:px-8">
        {/* White card that starts right under the header */}
        <div className="mt-2 bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          {/* Sticky action bar pinned top-right inside the card */}
          <div className="sticky top-0 z-30 flex justify-end items-center px-3 py-3 bg-white border-b border-gray-100">
            <TableActions
              requestId={id}
              onApproveSuccess={handleApproveSuccess}
              onApproveError={handleApproveError}
            />
          </div>

          {/* Form body */}
          <div className="p-4 md:p-6">
            <RecruitmentForm />
          </div>
        </div>
      </div>
    </div>
  );
};
